
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import RadioButton from '@/components/radio-button.vue'
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import basePerformanceDetail from './components/base-performance-detail.vue';
	import basePerformanceSubDetail from './components/base-performance-sub-detail.vue';
	import shopDistribution from './components/shop-distribution.vue'
	import PickerInterval from '@/components/picker-interval.vue';
	import Dialog from '@/components/dialog.vue';
	import UploadImg from '@/components/upload-img.vue';
	import {
		grade
	} from '@/utils/config';
	import {
		performanceStatisticList,
		productfilterBoxList,
		memberPerformanceofflinePerformanceImport,
	} from '@/api/statistic'
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"
	import axios from 'axios';

	@Component({
		name: 'member-performance',
		components: {
			RadioButton,
			PageFooter,
			PickerDate,
			basePerformanceDetail,
			basePerformanceSubDetail,
			shopDistribution,
			PickerInterval,
			'slz-dialog': Dialog,
			UploadImg
		}
	})
	export default class MemberPerformance extends Vue {
		private loading = false;
		private list: any = []
		private keywords = ''
		private superName = ''
		private filterTime: any = ''
		private radioType = null;
		private ProductIds:any = []
		private selectList = []
		private radioList: any = [{
				label: '全部',
				value: null
			}, {
				label: 'SVIC',
				value: 1
			}, {
				label: 'VIC',
				value: 2
			}, {
				label: 'VIP',
				value: 3
			}
		];
		private State = null;
		private StateList:any = [
			{value:null,label:'全部'},
			{value:0,label:'未审核'},
			{value:1,label:'已审核 '},
		]
		private gradeList = grade;
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png';
		
		private visible = false;
		private subVisible = false;
		private shopVisible = false
		private memberInfo:any = {};

		private sorttype:any = {
			order:'',
			prop:''
		}

		private retail = []
		private team = []

		private importType = 2
		private importShow = false
		private importMsg:any = {
			RelationTime:'',
			ExcelFilePath:[],
			ExcelFileName:'',
		}
		private importoption = {
			disabledDate:(e)=>{
				let now = new Date().getFullYear() +'-'+ (new Date().getMonth()+1)
				return new Date(this.lastmonth()).getTime() > new Date(e).getTime() || new Date(now).getTime() < new Date(e).getTime()
			}
		}
		private scheduleShow = false
		private handle = false
		private importId = 0
		private importresult:any = {
			FailCount:0,
			IsDealFinish:false,
			progress:0
		}


		// private mounted() {
		// 	this.initTime()
		// 	this.getshopList()
		// 	this.getList()
		// }
		private activated () {
			this.initTime()
			this.getshopList()
			this.getList()
		}

		private torecord(){
			this.$router.push({
				path:'base-performance-importrecord'
			})
		}
		private async confirmimport(){
			if(!this.importMsg.RelationTime){
				this.$message.error('请选择关联月份')
				return false
			}else if(!this.importMsg.ExcelFilePath){
				this.$message.error('请上传文件')
				return false
			}
			try{
				let res:any = await memberPerformanceofflinePerformanceImport({
					...this.importMsg,
					Type:this.importType,
					ExcelFilePath:this.importMsg.ExcelFilePath[0]
				})
				if(res.IsSuccess){
					this.importId = res.Result.RecordId
					this.gethandleresult(res.Result.RecordId,false)
					this.scheduleShow = true
					this.handle = true
				}
			}finally{
				//
			}
		}
		private async gethandleresult(RecordId,IsExport){
			try{
				let res:any = await axios.get('/pc/memberPerformance/offlinePerformanceImportResultExport'+`?RecordId=${RecordId}&IsExport=${IsExport}`,{
					responseType:IsExport?'blob':undefined,
				})
				if(!IsExport){
					if(res.data.IsSuccess){
						this.importresult = {
							...res.data.Result,
							progress:50,
						}
						if(!res.data.Result.IsDealFinish){
							this.importresult.progress = 50
							setTimeout(()=>{
								this.gethandleresult(RecordId,false)
							},500)
						}else{
							this.importresult = {
								...res.data.Result,
								progress:100,
							}
							this.handle = false
						}
					}else{
						this.$message.error(res.data.Message)
					}
				}else{
					let blob = new Blob([res.data],{type:"application/octet-stream; charset=utf-8"})
					let a = document.createElement('a')
					a.style.display = 'none'
					a.download = `${this.importType==2?'导入线下售后业绩':'导入线下手工单业绩'}反馈表格.xlsx`
					a.href = URL.createObjectURL(blob)
					a.click()
					a.remove()
				}
			}finally{
				//
			}
		}
		private lastmonth(){
			let now = new Date()
			let year = now.getFullYear()
			let month = now.getMonth()
			if(month == 0){
				month = 12
				year--
			}
			return year+'-'+(month>9?month:('0'+month))
		}
		private toinport(e){
			this.importType = e
			this.importMsg = {
				RelationTime:this.lastmonth(),
				ExcelFilePath:[]
			}
			this.importShow = true
		}
		private uploadSuc(file,name){
			this.importMsg.ExcelFilePath = file
			this.importMsg.ExcelFileName = name
		}

		private sortChange(row, column){
			// console.log(row)
			this.sorttype = {
				order:row.order=="ascending",
				prop:row.prop
			}
			this.getList()
		}

		private initTime(){
			this.filterTime = [getSearchDate(2,false,-6)[0],getSearchDate(2)[0]].join('/')
		}

		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.keywords = '';
			// this.filterTime = getSearchDate(1).join('/')
			this.initTime()
			this.superName = '';
			this.pageNo = 1;
			this.ProductIds = []
			this.retail = ['','']
			this.team = ['','']
			this.getList();
		}

		
		private testinterval(){
			let list = [...this.retail,...this.team]
			let two = /^\d+(\.\d{1,2})?$/
			for(let index in list){
				// console.log(index)
				if(list[index]&&!two.test(list[index])){
					this.$message.error('请输入数字，最多两位小数')
					return false
				}
				let num:any = index+1
				if(num%2==0&&list[index]>999999.99){
					this.$message.error('金额最大为999999.99')
					return false
				}
			}
			return true
		}

		private async getshopList(){
			try{
				const res:any = await productfilterBoxList({})
				if(res.IsSuccess){
					this.selectList = res.Result.map(v=>{
						let data = {
							value:v.Id,
							label:v.ProductName
						}
						return data
					})
				}
			}finally{
				//
			}
		}

		private async getList() {
			if(!this.testinterval()) return
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				RoleGrade: this.radioType?this.radioType:null,
				Keywords: this.keywords,
				SuperName: this.superName,
				State:this.State,
				ProductIds:this.ProductIds,
				MinPersonalPerformance:this.retail[0]||'',
				MaxPersonalPerformance:this.retail[1]||'',
				MinTeamPerformance:this.team[0]||'',
				MaxTeamPerformance:this.team[1]||'',
			}
			let times: any = '';
			if (this.filterTime){
				times = this.filterTime.split('/');
			}
			if (times) {
				params.StartTime = times[0];
				params.EndTime = nextDay(times[1],1)
			}
			this.loading = true;
			try {
				const res: any = await performanceStatisticList(params);
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e);
			} finally{
				this.loading = false;
			}
		}

		private exportlist(){
			if(!this.testinterval()) return
			let times: any = '';
			if (this.filterTime){
				times = this.filterTime.split('/');
			}
			let url = location.origin + '/pc/performanceStatistic/listexport?' + 
				'RoleGrade=' + (this.radioType?this.radioType:'') + 
				'&Keywords=' + this.keywords + 
				'&SuperName=' + this.superName + 
				'&StartTime=' + (times[0]||'') + 
				'&EndTime=' + (times[1]?nextDay(times[1],1):'')+
				'&ProductIds=' + this.ProductIds + 
				'&State=' + (this.State!==null?this.State:'') +
				'&MinPersonalPerformance=' + (this.retail[0]||'') +
				'&MaxPersonalPerformance=' + (this.retail[1]||'') +
				'&MinTeamPerformance=' + (this.team[0]||'') +
				'&MaxTeamPerformance=' + (this.team[1]||'')

			// console.log(url)
			window.open(url)
		}

		private exportDetail(){
			if(!this.testinterval()) return
			let times: any = '';
			if (this.filterTime){
				times = this.filterTime.split('/');
			}

			let url = location.origin + '/pc/performanceStatistic/detailExport?' + 
				'RoleGrade=' + (this.radioType?this.radioType:'') + 
				'&Keywords=' + this.keywords + 
				'&SuperName=' + this.superName + 
				'&StartTime=' + (times[0]||'') + 
				'&EndTime=' + (times[1]?nextDay(times[1],1):'')+
				'&ProductIds=' + this.ProductIds + 
				'&State=' + (this.State!==null?this.State:'') +
				'&MinPersonalPerformance=' + (this.retail[0]||'') +
				'&MaxPersonalPerformance=' + (this.retail[1]||'') +
				'&MinTeamPerformance=' + (this.team[0]||'') +
				'&MaxTeamPerformance=' + (this.team[1]||'')

			// console.log(url)
			window.open(url)
		}

		/**
		 * 业绩详情
		 */
		private toDetail(info: any) {
			// console.log(info,11)
			this.memberInfo = info;
			this.visible = true;
		}
		
		/**
		 * 下级出货详情
		 */
		private subDetail(info:any){
			this.memberInfo = info;
			this.subVisible = true;
		}

		private shopDetail(info:any){
			this.memberInfo = info;
			this.shopVisible = true;
		}
	}
